import brand from '@helpers/brand';
import { Device, until } from '@helpers/media';
import Link from '@stories/Components/Link/Link';
import TopLinksStyles from '@stories/Components/TopLinks/TopLinks.styles';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
const Container = styled.header `
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  transform: translateY(-120px);
  transition: transform 0.3s ease-out;
  width: 100%;
  z-index: 200;

  ${({ visible }) => visible &&
    css `
      transform: translateY(0px);
    `}
`;
const Inner = styled.div `
  position: relative;
  display: flex;
  backdrop-filter: blur(4px);
  background: ${rgba(brand.white, 0.95)};
  border-bottom: 1px solid ${brand.grey.grey96};
  height: 104px;
  z-index: 2;

  ${TopLinksStyles.Container} {
    position: absolute;
    top: 0;
    right: 0;
  }

  @media ${until(Device.Desktop)} {
    background: ${brand.white};
    height: 46px;
  }
`;
const LogoLink = styled(Link) `
  position: relative;
  display: flex;
  align-items: center;
  background: ${brand.grey.grey96};
  clip-path: polygon(0% 0%, 100% 0%, calc(100% - 32px) 100%, 0% 100%);
  height: 120px;
  justify-content: flex-start;
  padding: 0 56px 0 32px;
  outline: none;
  z-index: 2;

  &:focus {
    outline: none;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: ${brand.white};
    clip-path: polygon(0% 0%, 100% 0%, calc(100% - 32px) 100%, 0% 100%);
    height: calc(100% - 1px);
    width: calc(100% - 1px);
    z-index: 1;
  }

  @media ${until(Device.Desktop)} {
    clip-path: polygon(0% 0%, 100% 0%, calc(100% - 20px) 100%, 0% 100%);
    height: 68px;
    padding: 0 30px 0 18px;
    z-index: 2;

    &::before {
      clip-path: polygon(0% 0%, 100% 0%, calc(100% - 20px) 100%, 0% 100%);
    }
  }
`;
const Logo = styled.span `
  position: relative;
  z-index: 1;
  display: block;
  color: ${brand.black};
  height: 42px;
  width: 224px;

  @media ${until(Device.Desktop)} {
    height: 24px;
    width: 124px;
  }
`;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;
  z-index: 199;

  &[data-active='true'] {
    opacity: 1;
    pointer-events: all;
  }

  @media ${until(Device.Desktop)} {
    display: none;
  }
`;
export default {
    Container,
    Inner,
    Logo,
    LogoLink,
    Overlay,
};
